<script>
    import css from "./spinner.css";
</script>

<div class="{css.spinner}"></div>